module.exports = __webpack_public_path__ + "static/img/warm.4597b54b.png";